import { AxiosResponse } from 'axios';
import { DateTime } from 'luxon';
import { HttpResponseList } from 'shell/models/http-response';
import { PublishedEvent } from 'shell/models/pubblished-event';
import { PublishedEventsClient } from '../list/types';

export interface PublishedEventsResponse {
  pageInfo:
    | {
        totalCount: number;
        page: number;
        pageSize: number;
      }
    | undefined;
  pubblishedEvents: Array<PublishedEventsClient>;
}

export const transformPublishedEvents = (
  response: AxiosResponse<HttpResponseList<PublishedEvent>>
): PublishedEventsResponse => {
  const data = response.data.payload?.list || [];
  const pageInfo = response.data.payload?.pageInfo;

  if (pageInfo) {
    pageInfo.page = pageInfo.page / pageInfo.pageSize;
  }

  return {
    pageInfo,
    pubblishedEvents: data.map((publishedEvent: PublishedEvent) => ({
      id: publishedEvent?.id,
      eventDescription: publishedEvent?.descrizioneTipoEvento,
      dataTimePublication:
        DateTime.fromISO(publishedEvent?.dataOraPubblicazione).toFormat('dd/MM/yyyy HH:mm:ss') ||
        publishedEvent?.dataOraPubblicazione,
      typeEventCode: publishedEvent?.codiceTipoEvento,
      hidden: {
        delete: true,
        edit: true,
      },
    })),
  };
};
